/**
 * @param {Date} rightDateOperand The date parameter on the right when performing date arithmetic
 * @param {Date} leftDateOperand The date parameter on the left when performing date arithmetic
 */
export function GetMonthDifference(rightDateOperand, leftDateOperand) {
    var diff = (new Date(rightDateOperand).getTime() - new Date(leftDateOperand).getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7 * 4);
    return Math.abs(Math.round(diff));
}

// Format date to MM-YYYY
export function FormatDate(date, format){
    date = new Date(date);
    if(format == "MM-YYYY") {
        const month = date.toLocaleString('default', { month: '2-digit' });
        const year = date.toLocaleString('default', { year: 'numeric' });
        return month + '-' + year;
    }
    else if(format == "YYYY-MM-DD"){
        const day = date.toLocaleString('default', { day: '2-digit' });
        const month = date.toLocaleString('default', { month: '2-digit' });
        const year = date.toLocaleString('default', { year: 'numeric' });
        return year + '-' + month + '-' + day;
    }
    else if(format == "MMM-YYYY"){
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.toLocaleString('default', { year: 'numeric' });
        return month + '-' + year;
    }
    return "";
}